<div class="row">
    <div class="form-group col-12 col-lg-6">
        <label for="tipoPagamento" class="col-form-label">Tipo de Pagamento</label>
        <select class="form-control" name="tipoPagamento" id="tipoPagamento"
            [ngModel]="entity.tipoPagamento || ''" (ngModelChange)="onChangeTipoPagamento($event ? $event : null)"
            #tipoPagamento="ngModel" [disabled]="!canEditTipoPagamento">
            <option value="">Selecione a condição...</option>
            <option *ngFor="let tipo of tiposCondicoesPagamento" [ngValue]="tipo.id">{{tipo.nome}}</option>
        </select>         
    </div>
</div>
<!-- Prazos -->
<div class="row container-prazos" *ngIf="isTipoPagamentoPrazo()">
    <div class="col-12">
        <div class="card">
            <div class="card-header">
               Prazos
            </div>
            <div class="card-body">
                <div class="row" *ngIf="entity.prazosPagamento && entity.prazosPagamento.length > 0">
                    <div class="form-group col-12 col-lg-3" 
                        *ngFor="let entityPrazoPagamento of entity.prazosPagamento; let i = index">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">{{entityPrazoPagamento.sequencia}}º</span>
                            </div>                            
                            <input type="number" class="form-control" [(ngModel)]="entityPrazoPagamento.prazo" name="prazoPagamento_{{entityPrazoPagamento.sequencia}}" id="prazoPagamento_{{entityPrazoPagamento.sequencia}}"
                                #prazoPagamento="ngModel" [disabled]="!canEdit" [readonly]="!canEdit">
                            <div class="input-group-append" *ngIf="canEdit">
                                <button class="btn btn-light" type="button" (click)="delete(i)" tabindex="-1">
                                    <i class="far fa-trash-alt" aria-hidden="true"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="form-group col-12 col-lg-3" *ngIf="canEdit">
                        <button type="button" class="btn btn-primary" (click)="insert()">
                            <i class="fas fa-plus" aria-hidden="true"></i> Adicionar Prazo
                        </button>                
                    </div>
                </div>

                <ng-template [ngIf]="canEdit">
                    <div class="alert alert-info alert-no-entities" *ngIf="!entity.prazosPagamento || entity.prazosPagamento.length === 0">
                        <h5 class="title">
                            <i class="fas fa-info" aria-hidden="true"></i>Nenhum Prazo Adicionado
                        </h5>        
                        <button type="button" class="btn btn-primary" (click)="insert()">
                            <i class="fas fa-plus" aria-hidden="true"></i> Começar a Adicionar
                        </button>
                    </div>                
                </ng-template>
            </div>
        </div>
    </div>
</div>